export default __webpack_public_path__ + "static/media/ocr.794da19a.jpg";